import {
  APP_NAME,
  resolveDocumentTitle,
  resolveMetaDescription,
} from './appIdentity';

const DEFAULT_FAVICON = '/favicon.png';
const DEFAULT_APPLE_TOUCH_ICON = '/icons/platform-192.png';
const DEFAULT_THEME_COLOR = '#000000';

function upsertLink(rel, href, type) {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
  if (type) {
    link.type = type;
  } else {
    link.removeAttribute('type');
  }
}

function setMetaDescription(content) {
  const description = String(content || '').trim() || APP_NAME;
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'description');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', description);
}

function removeManifestLink() {
  document.querySelector('link[rel="manifest"]')?.remove();
}

function setThemeColor(color) {
  const themeColor = String(color || '').trim() || DEFAULT_THEME_COLOR;
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'theme-color');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', themeColor);
}

function resolveTenantLogoPath(config) {
  return String(config?.branding?.logoPath || '').trim() || null;
}

/**
 * Updates browser chrome (title, description, favicon, theme color) for the active tenant.
 */
export function applyDocumentBranding(config) {
  removeManifestLink();

  if (!config) {
    document.title = APP_NAME;
    setMetaDescription(APP_NAME);
    upsertLink('icon', DEFAULT_FAVICON, 'image/png');
    upsertLink('apple-touch-icon', DEFAULT_APPLE_TOUCH_ICON);
    setThemeColor(DEFAULT_THEME_COLOR);
    return;
  }

  document.title = resolveDocumentTitle(config);
  setMetaDescription(resolveMetaDescription(config));

  const logoPath = resolveTenantLogoPath(config);
  if (logoPath) {
    upsertLink('icon', logoPath, 'image/png');
    upsertLink('apple-touch-icon', logoPath);
  } else {
    upsertLink('icon', DEFAULT_FAVICON, 'image/png');
    upsertLink('apple-touch-icon', DEFAULT_APPLE_TOUCH_ICON);
  }

  setThemeColor(config?.branding?.primaryColor || DEFAULT_THEME_COLOR);
}
